import React from "react";

export default function ContentContainer({ children, containerTitle, className }) {
    return (
        <div className='w-full'>
            <div className='mb-5'></div>
            {/* <Breadcrumbs items={breadcrumbItems} />
            <div className='mb-5'></div> */}
            <p className='text-lg font-bold'>{containerTitle}</p>
            <div className='mb-2'></div>
            {children}
            <div className='h-[50px]'></div>
        </div>
    )
}